export const SLICE_NAME = 'metalReport';
